export default __webpack_public_path__ + "static/media/how-to-use.acd3672d.pdf";